export const CLOSE_ACCOUNT_TAG = 'uam/Accountsettings/closeRequested';
